/* Orbe Paris — carrousel avis (auto-scroll + navigation par flèches)
   L'autoplay ne tourne QUE quand toutes ces conditions sont réunies :
   carrousel visible dans le viewport (IntersectionObserver), pas de
   prefers-reduced-motion, et aucune interaction en cours (hover, focus
   clavier dans la section, touch, ou répit après un clic de flèche).
   Dès qu'une condition tombe, la boucle rAF est ANNULÉE
   (cancelAnimationFrame) — pas de boucle qui tourne à vide, jamais
   deux boucles simultanées (id unique). Les flèches et le défilement
   manuel restent toujours disponibles, autoplay actif ou non. */
(function () {
  document.querySelectorAll('[data-orbe-carousel]').forEach(function (track) {
    var speedSec = parseFloat(track.getAttribute('data-speed')) || 30;
    var autoplayEnabled = track.getAttribute('data-autoplay') !== 'false';

    var section = track.closest('section') || document;
    var prevBtn = section.querySelector('[data-orbe-carousel-prev]');
    var nextBtn = section.querySelector('[data-orbe-carousel-next]');

    function cardStep() {
      var card = track.querySelector('.orbe-avis__card');
      if (!card) return track.clientWidth * 0.8;
      var styles = window.getComputedStyle(track.querySelector('.orbe-avis__list') || track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    // --- États (chacun suspend l'autoplay tant qu'il est vrai)
    var motionQuery = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    var motionReduced = motionQuery ? motionQuery.matches : false;
    var inView = false;
    var hovering = false;
    var touching = false;
    var focused = false;
    var settleTimer = null;

    function isPaused() {
      return hovering || touching || focused || settleTimer !== null;
    }

    // Répit après une action volontaire (flèche, fin de touch) avant reprise.
    function settle(ms) {
      if (settleTimer) clearTimeout(settleTimer);
      settleTimer = setTimeout(function () {
        settleTimer = null;
        sync();
      }, ms);
      sync();
    }

    // --- Boucle rAF : id unique, annulée proprement à l'arrêt.
    var rafId = null;
    var lastTs = null;

    function tick(ts) {
      if (lastTs == null) lastTs = ts;
      var dt = (ts - lastTs) / 1000;
      lastTs = ts;

      var max = track.scrollWidth - track.clientWidth;
      if (max > 0) {
        var pxPerSec = max / speedSec;
        var next = track.scrollLeft + pxPerSec * dt;
        if (next >= max - 1) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          track.scrollLeft = next;
        }
      }
      rafId = requestAnimationFrame(tick);
    }

    function startLoop() {
      if (rafId !== null) return;
      lastTs = null;
      rafId = requestAnimationFrame(tick);
    }

    function stopLoop() {
      if (rafId !== null) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
      lastTs = null;
    }

    function sync() {
      if (autoplayEnabled && inView && !motionReduced && !isPaused()) {
        startLoop();
      } else {
        stopLoop();
      }
    }

    // --- Navigation par flèches (toujours active, autoplay ou non)
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        settle(4000);
        track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        settle(4000);
        var max = track.scrollWidth - track.clientWidth;
        if (track.scrollLeft >= max - 1) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: cardStep(), behavior: 'smooth' });
        }
      });
    }

    // --- Interactions utilisateur
    track.addEventListener('mouseenter', function () { hovering = true; sync(); });
    track.addEventListener('mouseleave', function () { hovering = false; sync(); });
    track.addEventListener('touchstart', function () { touching = true; sync(); }, { passive: true });
    track.addEventListener('touchend', function () { touching = false; settle(1500); }, { passive: true });
    track.addEventListener('touchcancel', function () { touching = false; settle(1500); }, { passive: true });

    // Pause tant qu'un élément de la section a le focus clavier
    // (flèches, piste tabbable…). relatedTarget = prochain élément focusé.
    section.addEventListener('focusin', function () { focused = true; sync(); });
    section.addEventListener('focusout', function (e) {
      focused = e.relatedTarget ? section.contains(e.relatedTarget) : false;
      sync();
    });

    if (motionQuery && motionQuery.addEventListener) {
      motionQuery.addEventListener('change', function (e) {
        motionReduced = e.matches;
        sync();
      });
    }

    // --- Visibilité : l'autoplay ne tourne que si le carrousel est à l'écran.
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          inView = entry.isIntersecting;
          sync();
        });
      }).observe(track);
    } else {
      inView = true;
      sync();
    }
  });
})();

/* Orbe Paris — socle motion : apparition au scroll (Reveal + Stagger + Trace)
   Les éléments qui entrent dans le viewport au même instant reçoivent un
   index --orbe-i (plafonné à 5) : le CSS les décale de 90 ms chacun.
   L'index est retiré après l'entrée pour ne pas retarder d'éventuelles
   transitions ultérieures sur le même élément. */
(function () {
  var targets = document.querySelectorAll('.orbe-reveal, .orbe-trace, .orbe-stagger');
  if (!targets.length) return;

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduceMotion || !('IntersectionObserver' in window)) {
    targets.forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  function clearStaggerAfterEntry(el) {
    el.addEventListener('transitionend', function handler(e) {
      if (e.target !== el) return;
      el.style.removeProperty('--orbe-i');
      el.removeEventListener('transitionend', handler);
    });
  }

  var observer = new IntersectionObserver(function (entries) {
    var batch = entries
      .filter(function (entry) { return entry.isIntersecting; })
      .sort(function (a, b) {
        return (
          a.boundingClientRect.top - b.boundingClientRect.top ||
          a.boundingClientRect.left - b.boundingClientRect.left
        );
      });

    batch.forEach(function (entry, i) {
      var el = entry.target;
      // Les conteneurs .orbe-stagger gèrent leur cascade en CSS (nth-child) :
      // pas d'index de batch sur eux.
      if (i > 0 && !el.classList.contains('orbe-stagger')) {
        el.style.setProperty('--orbe-i', Math.min(i, 5));
        clearStaggerAfterEntry(el);
      }
      el.classList.add('is-visible');
      observer.unobserve(el);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  targets.forEach(function (el) {
    observer.observe(el);
  });
})();

/* Orbe Paris — scrollytelling compression (section logistique-orbe-v6)
   Bidirectionnel : une étape s'active quand elle entre dans le viewport,
   et se désactive quand on remonte AU-DESSUS d'elle (sortie par le bas
   de l'écran) — le rail se vide et le galet se recompresse, puis tout se
   rejoue à la descente. Une étape déjà dépassée (sortie par le haut)
   reste active : on ne rejoue pas l'animation dans le dos du lecteur.
   data-orbe-state = index de la plus haute étape active (0 si aucune).
   Sans IO ou en mouvement réduit : état final posé, sans transition.
   Aucun listener scroll, aucun rAF, observer permanent unique. */
(function () {
  var section = document.querySelector('[data-orbe-compression]');
  if (!section) return;
  var steps = section.querySelectorAll('[data-orbe-step]');
  if (!steps.length) return;

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setFinalState() {
    steps.forEach(function (step) {
      step.classList.add('is-active');
    });
    section.setAttribute('data-orbe-state', String(steps.length));
  }

  if (reduceMotion || !('IntersectionObserver' in window)) {
    setFinalState();
    return;
  }

  function syncState() {
    var state = 0;
    steps.forEach(function (step) {
      if (step.classList.contains('is-active')) {
        var index = parseInt(step.getAttribute('data-orbe-step'), 10) || 0;
        if (index > state) state = index;
      }
    });
    section.setAttribute('data-orbe-state', String(state));
  }

  // Sur smartphone, les étapes sont hautes : on déclenche plus tôt (moins de
  // hauteur visible requise + zone de déclenchement plus basse dans l'écran).
  var isMobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
  var activateRatio = isMobile ? 0.35 : 0.5;
  var bottomMargin = isMobile ? '-5%' : '-12%';

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var step = entry.target;
      if (entry.isIntersecting && entry.intersectionRatio >= activateRatio) {
        step.classList.add('is-active');
      } else if (!entry.isIntersecting) {
        // Sortie complète par le bas du viewport = l'utilisateur est
        // remonté au-dessus de l'étape → on la désarme pour le replay.
        var rootBottom = entry.rootBounds ? entry.rootBounds.bottom : window.innerHeight;
        if (entry.boundingClientRect.top >= rootBottom) {
          step.classList.remove('is-active');
        }
      }
    });
    syncState();
  }, { threshold: [0, activateRatio], rootMargin: '0px 0px ' + bottomMargin + ' 0px' });

  steps.forEach(function (step) {
    observer.observe(step);
  });
})();

/* Orbe Paris — lookbook showroom : choix du décor (section lookbook-orbe-v5).
   Desktop uniquement (sur mobile, la galerie scroll-snap se suffit).
   Survol d'un nom = aperçu ; clic = choix (stoppe la rotation pour de bon).
   Rotation automatique douce (6 s, setInterval — pas de rAF) seulement si :
   visible (IO), pas de prefers-reduced-motion, aucune interaction en cours,
   pas de choix manuel. */
(function () {
  var root = document.querySelector('[data-orbe-lookbook]');
  if (!root) return;
  var items = root.querySelectorAll('[data-orbe-look-item]');
  var btns = root.querySelectorAll('[data-orbe-look-btn]');
  if (items.length < 2 || btns.length !== items.length) return;

  var motionQuery = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  var desktopQuery = window.matchMedia && window.matchMedia('(min-width: 1000px)');
  var current = 0;
  var chosen = false;
  var interacting = false;
  var inView = false;
  var timer = null;

  function setActive(index) {
    current = index;
    items.forEach(function (el, i) {
      el.classList.toggle('is-active', i === index);
    });
    btns.forEach(function (btn, i) {
      btn.classList.toggle('is-active', i === index);
      btn.setAttribute('aria-pressed', String(i === index));
    });
  }

  function start() {
    if (timer || chosen || interacting || !inView) return;
    if (motionQuery && motionQuery.matches) return;
    if (desktopQuery && !desktopQuery.matches) return;
    timer = setInterval(function () {
      setActive((current + 1) % items.length);
    }, 6000);
  }

  function stop() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }

  btns.forEach(function (btn, i) {
    btn.addEventListener('click', function () {
      chosen = true;
      stop();
      setActive(i);
    });
    btn.addEventListener('mouseenter', function () {
      setActive(i);
    });
  });

  root.addEventListener('mouseenter', function () { interacting = true; stop(); });
  root.addEventListener('mouseleave', function () { interacting = false; start(); });
  root.addEventListener('focusin', function () { interacting = true; stop(); });
  root.addEventListener('focusout', function (e) {
    interacting = e.relatedTarget ? root.contains(e.relatedTarget) : false;
    if (!interacting) start();
  });

  if (motionQuery && motionQuery.addEventListener) {
    motionQuery.addEventListener('change', function (e) {
      if (e.matches) stop(); else start();
    });
  }

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        inView = entry.isIntersecting;
        if (inView) start(); else stop();
      });
    }).observe(root);
  } else {
    inView = true;
    start();
  }
})();

/* Orbe Paris — cartes formats : détail au tap sur écran tactile.
   Sur desktop (pointeur fin), le hover/focus gère l'état actif en CSS pur ;
   ici on ne traite que les écrans sans survol. Une seule carte ouverte à
   la fois. Les clics sur le CTA (lien) ne sont jamais interceptés. */
(function () {
  var grid = document.querySelector('[data-orbe-format-grid]');
  if (!grid) return;

  grid.addEventListener('click', function (e) {
    if (e.target.closest('a')) return;
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var card = e.target.closest('[data-orbe-format-card]');
    if (!card) return;
    var wasOpen = card.classList.contains('is-open');
    grid.querySelectorAll('[data-orbe-format-card].is-open').forEach(function (c) {
      c.classList.remove('is-open');
    });
    if (!wasOpen) card.classList.add('is-open');
  });
})();

/* === Orbe : panier — animation suppression + maj badge + filet de sécurité total === */
(function () {
  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  onReady(function () {
    // 1. Animation suppression : actif globalement (n'affecte que les pages avec cart-remove-button).
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('cart-remove-button');
      if (!btn) return;
      var row = btn.closest('.cart-item');
      if (row) row.classList.add('orbe-removing');
    }, true);

    // 2. Filet de sécurité — n'installe le hook fetch qu'en présence du custom element cart-items
    //    (donc uniquement sur /cart). Si pas là, on n'altère pas window.fetch.
    if (!document.querySelector('cart-items')) return;

    var origFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      var url = '';
      try { url = (typeof input === 'string') ? input : (input && input.url) || ''; } catch (e) {}
      var p = origFetch(input, init);
      if (/\/cart\/(change|update|add)(\.js)?/i.test(url)) {
        // Programme un refresh — n'utilise PAS p.then pour ne pas consommer la réponse.
        setTimeout(refreshOrbeCart, 350);
      }
      return p;
    };
  });

  function refreshOrbeCart() {
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart) return;
        // Total estimé
        var formatted = formatMoney(cart.total_price);
        document.querySelectorAll('.totals__total-value').forEach(function (el) {
          if (el.textContent.trim() !== formatted.trim()) {
            el.textContent = formatted;
            el.classList.add('orbe-total-bump');
            setTimeout(function () { el.classList.remove('orbe-total-bump'); }, 500);
          }
        });
        // Badge header
        document.querySelectorAll('[data-orbe-cart-count]').forEach(function (el) {
          if (cart.item_count > 0) {
            el.textContent = cart.item_count;
            el.removeAttribute('hidden');
          } else {
            el.textContent = '';
            el.setAttribute('hidden', '');
          }
        });
        // États is-empty pour styles Dawn
        var ci = document.querySelector('cart-items');
        var cf = document.getElementById('main-cart-footer');
        if (ci) ci.classList.toggle('is-empty', cart.item_count === 0);
        if (cf) cf.classList.toggle('is-empty', cart.item_count === 0);
        // Si vide, vider la zone erreur Dawn (au cas où elle aurait gardé un message)
        var errBox = document.getElementById('cart-errors');
        if (errBox) errBox.textContent = '';
      })
      .catch(function () {});
  }

  function formatMoney(cents) {
    // Format français : 2 000,00 € EUR (espace insécable, virgule décimale)
    var euros = (cents / 100).toFixed(2);
    var parts = euros.split('.');
    var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return intPart + ',' + parts[1] + ' € EUR';
  }
})();

/* === Orbe : footer légal — garantit les 4 liens sur toutes les pages (contourne cache Shopify) === */
(function () {
  function fixFooter() {
    var copyright = document.querySelector('.footer__copyright');
    if (!copyright) return;

    // 1. Supprimer les anciens <small class="copyright__content"> qui contiennent © / Shopify / powered_by
    var smalls = copyright.querySelectorAll(':scope > small.copyright__content');
    smalls.forEach(function (s) {
      var t = s.textContent || '';
      var a = s.querySelector('a');
      if (/©|copyright|propulsé|Shopify/i.test(t) || (a && /shopify\.com/.test(a.getAttribute('href') || ''))) {
        s.remove();
      }
    });

    // 2. Construire la liste des 4 liens si elle n'est pas déjà complète
    var ul = copyright.querySelector('ul.policies');
    var required = [
      { href: '/pages/politique-confidentialite', label: 'Politique de confidentialité' },
      { href: '/pages/preferences-cookies', label: 'Préférences en matière de cookies' },
      { href: '/pages/conditions-generales-de-vente', label: 'CGV' },
      { href: '/pages/mentions-legales', label: 'Mentions légales' }
    ];

    if (!ul) {
      ul = document.createElement('ul');
      ul.className = 'policies list-unstyled';
      copyright.appendChild(ul);
    }

    // 3. Retirer tout li qui pointe vers /policies/* (URLs Shopify obsolètes)
    ul.querySelectorAll('li').forEach(function (li) {
      var a = li.querySelector('a');
      if (a && /\/policies\//.test(a.getAttribute('href') || '')) li.remove();
    });

    // 4. Ajouter les liens manquants
    var existingHrefs = Array.from(ul.querySelectorAll('a')).map(function (a) { return a.getAttribute('href'); });
    required.forEach(function (link) {
      if (existingHrefs.indexOf(link.href) === -1) {
        var li = document.createElement('li');
        li.innerHTML = '<small class="copyright__content"><a href="' + link.href + '">' + link.label + '</a></small>';
        ul.appendChild(li);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixFooter);
  } else {
    fixFooter();
  }
})();

/* Orbe Paris — Nuancier tissus (section nuancier-orbe-v1)
   Progressive enhancement : sans ce script, le nuancier reste OUVERT et
   utilisable (couverture masquée). Avec : couverture + ouverture animée,
   sélection des teintes en cross-fade (2 calques, chargement à la demande).
   Scope par section + shopify:section:load (Theme Editor), garde anti-double-init. */
(function () {
  function initNuancier(root) {
    if (!root || root.dataset.nuancierReady === '1') return;
    root.dataset.nuancierReady = '1';

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var animOn = root.getAttribute('data-anim') !== '0';
    var accentOn = root.getAttribute('data-accent') === '1';

    var cover = root.querySelector('[data-nuancier-open]');
    var spread = root.querySelector('[data-nuancier-spread]');
    var swatches = Array.prototype.slice.call(root.querySelectorAll('[data-nuancier-swatch]'));
    var layers = Array.prototype.slice.call(root.querySelectorAll('[data-nuancier-macro]'));
    var nameEl = root.querySelector('[data-nuancier-name]');
    var phraseEl = root.querySelector('[data-nuancier-phrase]');
    var mainCta = root.querySelector('[data-nuancier-main-cta]');

    root.classList.add('is-enhanced');
    if (!animOn || reduce) root.classList.add('orbe-nuancier--instant');

    function setInert(on) {
      if (!spread) return;
      if ('inert' in spread) spread.inert = on;
      spread.setAttribute('aria-hidden', on ? 'true' : 'false');
    }
    function openBook(focusInside) {
      root.classList.add('is-open');
      setInert(false);
      if (focusInside) {
        var a = root.querySelector('[data-nuancier-swatch].is-active') || swatches[0];
        if (a) a.focus({ preventScroll: true });
      }
      if (cover) { cover.setAttribute('aria-expanded', 'true'); cover.setAttribute('aria-hidden', 'true'); cover.tabIndex = -1; }
    }

    // Desktop : carnet fermé à l'arrivée, s'ouvre au clic. Mobile : ouvert d'emblée.
    var smallScreen = window.matchMedia && window.matchMedia('(max-width: 859px)').matches;
    if (cover && !smallScreen) {
      root.classList.remove('is-open');
      setInert(true);
      cover.setAttribute('aria-expanded', 'false');
      cover.addEventListener('click', function () { openBook(true); });
    } else {
      openBook(false);
    }

    var current = 0;
    for (var i = 0; i < layers.length; i++) {
      if (layers[i].classList.contains('is-current')) current = i;
    }

    function applyAccent(btn) {
      if (!accentOn) return;
      var a = btn.getAttribute('data-accent');
      if (a) root.style.setProperty('--nuancier-accent', a);
    }

    function setMainCta(btn) {
      if (!mainCta) return;
      var name = btn.getAttribute('data-name') || '';
      var tpl = mainCta.getAttribute('data-template') || 'Voir les modèles en {teinte}';
      mainCta.textContent = tpl.indexOf('{teinte}') !== -1 ? tpl.replace('{teinte}', name) : tpl;
      var link = btn.getAttribute('data-cta-link') || mainCta.getAttribute('data-default-link') || '#';
      mainCta.setAttribute('href', link);
    }

    function select(btn) {
      if (btn.getAttribute('aria-pressed') === 'true') return; // déjà active
      swatches.forEach(function (s) {
        var on = s === btn;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      var macro = btn.getAttribute('data-macro');
      var name = btn.getAttribute('data-name') || '';
      var phrase = btn.getAttribute('data-phrase') || '';
      var alt = btn.getAttribute('data-alt') || ('Gros plan du tissu Orbe Paris, teinte ' + name);

      if (layers.length >= 2 && macro) {
        var cur = layers[current];
        var nxt = layers[1 - current];
        var reveal = function () {
          nxt.classList.add('is-current');
          if (cur) cur.classList.remove('is-current');
          current = 1 - current;
        };
        nxt.alt = alt;
        if (nxt.getAttribute('src') === macro) {
          reveal();
        } else {
          nxt.onload = reveal;
          nxt.onerror = null;
          nxt.setAttribute('src', macro);
        }
      } else if (layers.length === 1 && macro) {
        layers[0].setAttribute('src', macro);
        layers[0].alt = alt;
      }

      if (nameEl) nameEl.textContent = name;
      if (phraseEl) {
        phraseEl.textContent = phrase;
        if (phrase) phraseEl.removeAttribute('hidden'); else phraseEl.setAttribute('hidden', '');
      }
      applyAccent(btn);
      setMainCta(btn);
    }

    swatches.forEach(function (btn) {
      btn.addEventListener('click', function () { select(btn); });
    });

    var initActive = root.querySelector('[data-nuancier-swatch].is-active') || swatches[0];
    if (initActive) { applyAccent(initActive); setMainCta(initActive); }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-nuancier]').forEach(initNuancier);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) initAll(e.target);
  });
})();
